<template>
  <el-card class="main-content">
    <div class="actions">
      <div class="publish-switch">
        <i class="el-icon-view icon-preview" @click="routeToPreview"></i>
        <el-switch
          v-model="published"
          inactive-text="发布:"
          active-color="#13ce66"
          inactive-color="#f3f3f3"
        >
        </el-switch>
      </div>
      <DeletePopover placement="bottom" @delete="deleteRelease">
        <el-button class="main-button" size="small" type="danger"
          >删除</el-button
        >
      </DeletePopover>
      <el-button
        class="main-button ml-10"
        type="primary"
        size="small"
        @click="updateRelease"
        :loading="updating"
        >保存</el-button
      >
    </div>
    <div class="row">
      <div class="col">
        <span>版本名:</span>
        <el-input v-model="release.title"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span>标签:</span>
        <TagsEdit
          :tags="release.tags"
          @add="onTagAdd"
          @delete="onTagDelete"
        ></TagsEdit>
      </div>
    </div>
    <div class="readme">
      <span>描述:</span>
      <TextEditor :content.sync="release.readme"></TextEditor>
    </div>
    <div class="mt-10">
      <span>资料集:</span>
      <ReleaseReposAdminTransfer
        :releaseRepos="releaseRepos"
        @change="updateReleaseReposID"
      ></ReleaseReposAdminTransfer>
    </div>
  </el-card>
</template>

<script>
import { OopsErrorELMessage, ReleaseMixin } from "@/mixins";
import DeletePopover from "@/components/DeletePopover";
import TagsEdit from "@/components/TagsEdit";
import TextEditor from "@/components/TextEditor";
import ReleaseReposAdminTransfer from "@/components/ReleaseReposAdminTransfer";
export default {
  name: "ReleaseEdit",
  mixins: [OopsErrorELMessage, ReleaseMixin],
  components: {
    DeletePopover,
    TagsEdit,
    TextEditor,
    ReleaseReposAdminTransfer
  },
  data() {
    return {
      updating: false,
      deleting: false
    };
  },
  computed: {
    updateRequest() {
      return {
        title: this.release.title,
        readme: this.release.readme
      };
    },
    releaseRepos() {
      return this.release.repos;
    }
  },
  methods: {
    updateRelease() {
      this.updating = true;
      this.$http
        .patch(this.releaseURI, this.updateRequest)
        .then(resp => {
          this.release = resp.data;
          this.updating = false;
          this.$message({
            type: "success",
            message: "更新完成",
            duration: 600
          });
        })
        .catch(() => {
          this.updating = false;
          this.oopsError();
        });
    },
    updateReleaseReposID(reposID) {
      let req = { repos_id: reposID };
      this.updating = true;
      this.$http
        .patch(this.releaseURI, req)
        .then(resp => {
          this.release.repos = resp.data.repos;
          this.updating = false;
        })
        .catch(() => {
          this.updating = false;
          this.oopsError();
        });
    },
    deleteRelease() {
      this.deleting = true;
      this.$http
        .delete(this.releaseURI)
        .then(() => {
          this.$router.push({ name: "admin_releases" });
        })
        .catch(() => {
          this.oopsError();
          this.deleting = false;
        });
    },
    publishReleaseSwitch() {
      this.$http
        .patch(this.releaseURI, {
          publish: !this.published
        })
        .then(resp => {
          this.release.published_at = resp.data.published_at;
        })
        .catch(err => this.oopsError(err));
    },
    onTagAdd(name) {
      this.$http
        .post(`${this.releaseURI}/tags`, { name })
        .then(resp => {
          this.release.tags.push(resp.data);
        })
        .catch(() => this.oopsError());
    },
    onTagDelete(tag) {
      this.$http
        .delete(`${this.releaseURI}/tags/${tag.id}`)
        .then(() => {
          let idx = this.release.tags.findIndex(t => t.id === tag.id);
          this.release.tags.splice(idx, 1);
        })
        .catch(() => this.oopsError());
    },
    routeToPreview() {
      this.$router.push({
        name: "release_preview",
        params: { release_id: this.releaseID }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
.actions {
  display: flex;
  justify-content: flex-end;
  & .publish-switch {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
}
.icon-preview {
  margin-right: 5px;
  color: #68b4ff;
  cursor: pointer;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;
  margin: 10px 0;
}
.col {
  display: grid;
  align-items: center;
  grid-template-columns: 80px 1fr;
}
.script-editor {
  margin-top: -15px;
}
.archive-upload {
  align-items: unset;
}
</style>
